import styled from "styled-components";
import { colors, types } from "../../../libs";

export const StyledCard = styled.div<{
  compact?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid transparent;
  background:  ${colors.background.lightBlack};
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: ${props => props.compact ? '0' : '16px'};
  width: 100%;
  cursor: pointer;
`;

export const SvgImage = styled.img`
  border-radius: 4px;
  width: 90px;
  height: 60px;
  
`;

export const SvgPlaceholder = styled.div`
  width: 90px;
  height: 60px;
  border-radius: 4px;
`;

export const CardText = styled.div`
  flex: 1;
  margin-left: 12px;
  text-align: left;
`;

export const Title = styled.div`
   ${types.body.normal};
  font-weight: bold;
  color:  ${colors.text.white};
`;

export const Subtitle = styled.div`
 ${types.body.small};
  color: ${colors.text.gray};
`;

export const Circle = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50px;
  background: ${colors.background.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
    &:hover {
    background: ${colors.background.greyWhite};
  }
`;
export const CenteredIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 12px; 
    margin-right: 8px;
`;
